let totalResources: number = 0;

export function getTotalResourceCount(): number {
    return totalResources;
}

export function increaseResources(value: number): void {
    totalResources += value;
}
